<template>
  <div>
    <div :class="['b-share sm:hidden', size ? size : '']">
      <!-- CRM汎用独自対応 -->
      <!-- <template v-if="social">
        <span class="lg:hidden">{{label}}</span>
        <a class="b-share-item lg:hidden" target="_blank" :href="shareFacebook" v-if="facebook">
          <i class="icon icon-bor-facebook" />
        </a>
        <a class="b-share-item lg:hidden" target="_blank" :href="shareTwitter" v-if="twitter">
          <i class="icon icon-bor-twitter" />
        </a>
        <a class="b-share-item lg:hidden" target="_blank" :href="shareLine" v-if="line">
          <i class="icon icon-bor-line" />
        </a>
        <a class="b-share-item lg:hidden" target="_blank" :href="shareEmail" v-if="email">
          <i class="icon icon-bor-envelope" />
        </a>
        <a class="b-share-item lg:hidden" @click="popupMail = true, errCode=''"  v-if="email">
          <i class="icon icon-bor-envelope" />
        </a>
        <PopUpSendMail  :visible="popupMail" @show="showPopup" @sendMail="sendMailToAddress($event)" :errCode="errCode" />
        <div class="divider-v lg:hidden"></div>
      </template>
      <div class="item-action lg:hidden" v-if="copy">
        <button class="c-btn btn-sm btn-white btn-copy" @click="doCopy">内容をコピー</button>
      </div> -->
      <!-- CRM汎用独自対応 -->
      <!-- <div v-if="social" class="item-action sm:hidden"> -->
      <div class="item-action sm:hidden">
        <a class="text-grey-600" href="#">
          <i class="icon icon-bor-circle-question" />
        </a>
      </div>
      <!-- CRM汎用独自対応 -->
      <!-- <div v-if="social" class="item-action sm:hidden">
        <a href="#" @click="showShare">
          <i class="icon icon-bor-upload share"></i>
        </a>
      </div> -->
     
      <div class="item-action sm:hidden" v-if="favorite">
        <a @click="handleFavorite">
          <i class="icon icon-bor-heart-solid" v-if="isFavorite" />
          <i class="icon icon-bor-heart" v-else/>
        </a>
      </div>
    </div>
    <InstructionLogin1 :visible="popupLogin" @ok="popupLogin = false" @cancel="popupLogin = false"/>
    <Modal :visible="popupShare" @ok="popupShare = false" @cancel="popupShare = false">
      <div class="b-share_inner">
        <!-- CRM汎用独自対応 -->
        <!-- <a class="b-share-item lg:hidden" target="_blank" :href="shareFacebook" v-if="facebook">
          <i class="icon icon-bor-facebook" />
        </a>
        <a class="b-share-item lg:hidden" target="_blank" :href="shareTwitter" v-if="twitter">
          <i class="icon icon-bor-twitter" />
        </a>
        <a class="b-share-item lg:hidden" target="_blank" :href="shareLine" v-if="line">
          <i class="icon icon-bor-line" />
        </a>
        <a class="b-share-item lg:hidden" target="_blank" :href="shareEmail" v-if="email">
          <i class="icon icon-bor-envelope" />
        </a> -->
        <a v-if="copy" class="b-share-item btn-copy">
          <i class="icon icon-bor-copy" />
        </a>
      </div>
    </Modal>

    <!-- mobile share and favourite icon wrapper -->
    <div class="hidden share-favourite sm:flex justify-center items-center">
        <div class="share-icon-wrapper px-2 sm:mt-0 sm:mr-2 border flex justify-center items-center cursor-pointer" @click="doCopy">
            <span class="txt whitespace-pre">共有</span>
            <span class="icon"><i class="icon icon-bor-upload share"></i></span>
        </div>
        <div class="favourite-icon-wrapper" @click="handleFavorite">
            <i class="icon icon-bor-heart-solid" v-if="isFavorite" />
            <i class="icon icon-bor-heart" v-else />
        </div>
    </div>    

  </div>
</template>

<script>
import _ from 'lodash'
import menu_utils from '@/mixins/menu_utils'
import func_utils from '@/mixins/func_utils'

export default {
  name: 'MenuShare',
  mixins: [menu_utils, func_utils],
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'シェア'
    },
    url: {
      type: String
    },
    success: {
      type: Function
    },
    error: {
      type: Function
    },
    facebook: {
      type: Boolean,
      default: true
    },
    twitter: {
      type: Boolean,
      default: true
    },
    line: {
      type: Boolean,
      default: true
    },
    email: {
      type: Boolean,
      default: true
    },
    copy: {
      type: Boolean,
      default: true
    },
    face: {
      type: Boolean,
      default: true
    },
    favorite: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'normal'
    },
    copyLabel: {
      type: String,
      default: null
    },
    social: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      menuNo: null,
      isFavorite: false,
      favoriteId: null,
      popupLogin: false,
      popupShare: false,
      popupMail: false,
      errCode: '0'
    }
  },
  created() {
    const { menuNo } = this.$route.params
    this.menuNo = menuNo
  },
  mounted() {
    if (this.$auth.loggedIn && this.favorite) {
      this.getFavoriteStatus(this.menuNo).then(
        (result) => {
          this.favoriteId = _.get(result, 'id', '')
          this.isFavorite = _.get(result, 'favourite', false)
        },
        () => {
          
        })
    }
  },
  watch: {
    
  },
  computed: {
    shareFacebook() {
      if (this.url) {
        return `https://www.facebook.com/sharer/sharer.php?u=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`
    },
    shareTwitter() {
      if (this.url) {
        return `https://twitter.com/intent/tweet?text=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://twitter.com/intent/tweet?text=${url}`
    },
    shareLine() {
      if (this.url) {
        return `https://social-plugins.line.me/lineit/share?url=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://social-plugins.line.me/lineit/share?url=${url}`
    },
    shareEmail() {
      if (this.url) {
        return `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&body=+${this.url}+&ui=2&tf=1&pli=1'`
      }
      // eslint-disable-next-line quotes
      return `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&body=+${location.href}+&ui=2&tf=1&pli=1'`
    }
  },
  methods: {
    showShare() {
      this.popupShare = true
    },
    doCopy() {
      let label = this.copyLabel
      let url = this.url
      if (!url) {
        url = location.href?.split('?')[0]
        if (this.$route?.query?.hasOwnProperty('adultHeadCnt')) {
          url = `${url}?adultHeadCnt=${this.$route.query.adultHeadCnt}`
        }
      }
      const copyData = [label, url].filter(Boolean).join('\n')
      this.$copyText(copyData).then(
        function (e) {
          alert('クリップボードにコピーしました')
        },
        function (e) {
          alert('クリップボードにコピーできませんでした')
        }
      )
    },
    handleFavorite() {
      if (!this.$auth.loggedIn) {
        this.popupLogin = true
        return
      }
      if (!this.isFavorite) {
        this.addFavorite(this.menuNo).then(
          (result) => {
            this.isFavorite = true
            this.favoriteId = _.get(result, 'id', null)
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
      } else {
        this.removeFavorite(this.favoriteId).then(
          () => {
            this.favoriteId = null
            this.isFavorite = false
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
      }
    },
    sendMailToAddress($event) {
      const menuNo = this.$route.params
      if(!$event) {
        this.errCode = '1'
      } else {
        let myEmail = null
        myEmail = $event.trim()
        if(this.validEmail(myEmail.trim())) {
          const data = {
            menuNo,          
            email: $event
          }
          this.$repositories('plan').sendMailToAddress(data).then(
            () => {
              this.popupMail = false
            },
            (error) => {
              this.popupMail = false
              this.$toasted.error(error?.message)
            }
          )
        } else {
          this.errCode = '2'
        }
      }
    },
    showPopup($event) {
      this.popupMail = $event
    },
    triggerSuccess(type, data) {
      this.$emit('success', {
        type,
        data
      })
    },
    triggerError(type, data) {
      this.$emit('error', {
        type,
        data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>